import { Injectable } from "@angular/core";
import { Capacitor } from "@capacitor/core";
import { AlertController, ToastController } from "@ionic/angular";
// import { Storage } from "@ionic/storage";
import moment from "moment";
@Injectable({
  providedIn: "root",
})
export class GlobalProvider {
  //new
  registerDetail:any ={};
  //new ends
  platform;
  loadingJwt = true;
  profileType;
  profile;
  companyName;
  accessRole;
  role;
  jws: string;
  notifications = [];
  auditLogAllow = false;
  docShareAllow = false;
  mediaUrl;
  topHeader;
  appLandingSite;
  iosVersion;
  androidVersion;
  cartLoaded = false;
  posCart = {
    items: [],
  };
  posSetting = {
    taxName: `GST`,
    taxRate: 0.08,
    taxRateInString: `8`,
  };

  appAnnouncement;
  toggleAppAnnouncement;

  accessCode;

  affiliateGroupCodeMessage;
  affiliateTopupLimit;
  affiliateGroupRemovalCountdown;

  topupDisclaimerMessage;

  termsAndConditions;
  pdpa;

  disableTopup = false;
  minTopup = 0.01;

  // token =
  //   "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwic3RhdHVzIjoiYWN0aXZlIiwiZmlyc3ROYW1lIjoicXpvbmV0ZWNoIiwibGFzdE5hbWUiOiJ0ZXN0IGFjY291bnQiLCJlbWFpbCI6ImF0aXFhaEBxem9uZXRlY2guY29tIiwiY29udGFjdFdDb2RlIjp7Im5hdGlvbmFsTnVtYmVyIjoiOTAwNyA5MDIyIiwiaW50ZXJuYXRpb25hbE51bWJlciI6Iis2NSA5MDA3IDkwMjIifSwiY29udGFjdEludGVybmF0aW9uYWxOdW1iZXIiOiIrNjUgOTAwNyA5MDIyeCIsImRvYiI6IjE5OTYtMDEtMTkiLCJwcm9maWxlUGljRmlsZSI6bnVsbCwibm90aWZpY2F0aW9uQ29uZmlnIjp7Im91dGxldHMiOnsiMSI6dHJ1ZX19LCJhY2Nlc3NDb2RlIjoiNzJPWVZQWlNPUVNCIiwiYWNjZXNzQ29kZUV4cGlyZWRBdCI6IjIwMjQtMDQtMDlUMTU6NTc6MTguMDAwWiIsImNyZWF0ZWRBdCI6IjIwMjMtMDYtMDZUMDg6MjQ6MzIuMDAwWiIsInVwZGF0ZWRBdCI6IjIwMjQtMDMtMTBUMTU6NTc6MTguMDAwWiIsImRlbGV0ZWRBdCI6bnVsbCwiYWNjb3VudElkIjo5LCJwcm9maWxlVHlwZSI6ImN1c3RvbWVyIiwiaWF0IjoxNzEyMDM4MTIxLCJleHAiOjE3NDgwMzQ1MjEsImF1ZCI6IlRJTUJSRSIsImlzcyI6IkxFTyIsInN1YiI6IlByb2ZpbGUifQ.Yad3TZTCt700zyhfUbadzCAGhv69h2DOVWHzmjFaTUsVgxABRUwekf_EQ6Mz9jbWwdAMgF72ItNqauDUKoJ4Xg"; // add value to do test
  token;
  refresherBg = false;
  gHasToken = false;
  globalSetting:any={};
  paynowData:any={};
  location:any={};

  constructor(
    // protected storage: Storage,
    protected toastController: ToastController,
    protected alertController: AlertController
  ) {
    // this.topHeader = 'padding-top: 40px;'; // testing
    if (Capacitor.getPlatform() === "ios") {
      this.topHeader = "padding-top: 60px;";
      this.refresherBg = false;
    } else if (Capacitor.getPlatform() !== "ios") {
      this.topHeader = "padding-top: 1em";
      this.refresherBg = true;
    }
  }

  async setMedia(mediaUrl) {
    // await this.storage.set(`mediaUrl`, mediaUrl);
    this.mediaUrl = mediaUrl;
  }

  roundOff(num, decimalPlace = 2, debug = false) {
    console.log("entered global roundoff. check passed num?", num);
    if (debug) {
      console.log(`num, decimalPlace!`, num, decimalPlace);
    }
    const na = Number(num)
      .toFixed(decimalPlace + 2)
      .split("");
    console.log("check na?", na);
    const lastNumber = Number(na[na.length - 2]);
    console.log("check lastNumber?", lastNumber);
    if (debug) {
      console.log(`lastNumber?!!`, lastNumber);
    }
    na.pop();
    na.pop();
    const newNumber = Number(na.join(""));
    if (debug) {
      console.log(`newNumber?!!`, newNumber);
    }
    if (lastNumber >= 5) {
      console.log("entered lastNumber is bigger or = 5", lastNumber);
      if (debug) {
        console.log(`rounding up`);
      }
      // round up
      let stringAdd = `0.`;
      for (let i = 0; i < decimalPlace - 1; i++) {
        stringAdd += `0`;
      }
      stringAdd += `1`;
      if (debug) {
        console.log(`stringAdd?!!`, stringAdd);
      }
      return Number((newNumber + Number(stringAdd)).toFixed(decimalPlace));
    } else {
      console.log("entered lastNumber is NOT bigger or = 5", lastNumber);
      // round down
      if (debug) {
        console.log(`rounding down!`, newNumber);
      }
      return Number(newNumber.toFixed(decimalPlace));
    }
  }

  async updateWallet(walletDetail){
    this.profile.wallet =walletDetail;
  }

  openNotification(){}
}
